'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-241/node_modules/@eliadmin/core/src/components/realty/realty-detail/realty-swiper.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-241/node_modules/@eliadmin/core/src/components/realty/realty-detail/realty-swiper.tsx").RealtiesSwiper>>;
const Deferred = lazy(() => import("@eliadmin/module-original/realtySlider").then(m => ({ default: m.RealtiesSwiper })));
export function RealtiesSwiper(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

